import { useState } from "react";
import { Marker, Popup } from "react-map-gl/mapbox";

export interface LocationPin {
  latitude: number;
  longitude: number;
  link_type: "automatic" | "included" | "excluded" | "primary";
  name: string;
}

interface LocationPinsProps {
  locations: LocationPin[];
}

const COLORS = {
  automatic: "#3b82f6",
  included: "#22c55e",
  excluded: "#9ca3af",
  primary: "#a855f7",
} as const;

const LABELS = {
  automatic: "Auto-matched",
  included: "Manually added",
  excluded: "Excluded",
  primary: "Primary place",
} as const;

export function LocationPins({ locations }: LocationPinsProps) {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const hovered = hoveredIndex !== null ? locations[hoveredIndex] : null;

  return (
    <>
      {locations.map((location, index) => (
        <Marker
          key={`${location.latitude}-${location.longitude}-${location.name}`}
          longitude={location.longitude}
          latitude={location.latitude}
        >
          <div
            role="img"
            aria-label={`${location.name} (${LABELS[location.link_type]})`}
            className="size-3 cursor-pointer rounded-full border-2 border-white shadow transition-transform hover:scale-150"
            style={{ backgroundColor: COLORS[location.link_type] }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          />
        </Marker>
      ))}

      {hovered && (
        <Popup
          longitude={hovered.longitude}
          latitude={hovered.latitude}
          offset={10}
          closeButton={false}
          closeOnClick={false}
          className="!p-0 [&_.mapboxgl-popup-content]:rounded-lg [&_.mapboxgl-popup-content]:px-3 [&_.mapboxgl-popup-content]:py-2 [&_.mapboxgl-popup-content]:shadow-lg"
        >
          <p className="text-sm font-medium text-primary">{hovered.name}</p>
          <p className="text-xs text-tertiary">{LABELS[hovered.link_type]}</p>
        </Popup>
      )}
    </>
  );
}
